import { t } from '@/lib/i18n';
import { useUpdateJob } from '../hooks';
import styles from './RememberOutputsToggle.module.css';

interface RememberOutputsToggleProps {
  jobId: string;
  current: boolean;
}

export function RememberOutputsToggle({ jobId, current }: RememberOutputsToggleProps) {
  const update = useUpdateJob(jobId);
  const id = `remember-outputs-${jobId}`;

  return (
    <div className={styles.row}>
      <input
        id={id}
        type="checkbox"
        checked={current}
        disabled={update.isPending}
        onChange={(e) => update.mutate({ remember_outputs: e.target.checked })}
      />
      <label htmlFor={id} className={styles.label}>
        <strong>
          <span aria-hidden="true">★ </span>
          {t("Remember this job's outputs")}
        </strong>
        <small className={styles.help}>
          {t('When on, the assigned Member can recall this job in future chats.')}
        </small>
      </label>
    </div>
  );
}
